export const BASE_URLS = {
    api: "/api",
    app: "https://fulfilweb.ru",
    // app: "http://localhost:3000",
    // api: "https://kodrf.ru/api",
};